/**
 * SkipLink - Accessibility component for keyboard navigation
 *
 * Allows keyboard users to skip repetitive navigation and jump
 * directly to main content. Hidden until focused.
 */
import { useState } from 'react'

export function SkipLink() {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <a
      href="#main-content"
      className="skip-link"
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
      style={{
        position: 'fixed',
        top: 0,
        left: isVisible ? 0 : '-9999px',
        zIndex: 99999,
        padding: '12px 24px',
        background: 'var(--brand-primary, #A78BFA)',
        color: '#FFFFFF',
        fontSize: '14px',
        fontWeight: 600,
        textDecoration: 'none',
        borderRadius: '0 0 8px 0',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
        outline: 'none',
      }}
    >
      Skip to main content
    </a>
  )
}

export default SkipLink
